import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CriterionLevel } from '../types';

interface Props {
  value: CriterionLevel;
  onChange: (level: CriterionLevel) => void;
  disabled?: boolean;
}

/** Bloquant : absent ⇒ exercice non validé. Attendu : son absence est signalée sans bloquer. */
const CriterionLevelSelect: React.FC<Props> = ({ value, onChange, disabled = false }) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    onChange={(_, level: CriterionLevel | null) => level && onChange(level)}
    disabled={disabled}
  >
    <ToggleButton value="blocking" color="error">Bloquant</ToggleButton>
    <ToggleButton value="expected" color="primary">Attendu</ToggleButton>
  </ToggleButtonGroup>
);

export default CriterionLevelSelect;
